import { Building } from './building'
import { Unit } from './unit'

export enum CreationStatus {
  DRAFTED = 'DRAFTED',
  COMPLETED = 'COMPLETED',
}

export enum Orientation {
  UNKNOWN = 'UNKNOWN',
  NORTH = 'NORTH',
  NORTHEAST = 'NORTHEAST',
  EAST = 'EAST',
  SOUTHEAST = 'SOUTHEAST',
  SOUTH = 'SOUTH',
  SOUTHWEST = 'SOUTHWEST',
  WEST = 'WEST',
  NORTHWEST = 'NORTHWEST',
}

export type Property = {
  id: string
  status?: {
    creationStatus: CreationStatus
    isPublished: boolean
  }
  building?: Building
  units?: Unit[]
  createdAt?: string
  updatedAt?: string
  totalSquareFootage?: number
  repartitionOfUnits?: {
    commercial: number
    residential: number
  }
  hasDetailedUnitInformation?: boolean
}
